import * as types from './action_types';
import * as UserActions from '../user/actions';
import TackPauser from '../../services/tack_pauser';
import Tacker from '../../services/tacker';
import LoggedOutTacker from '../../services/logged_out_tacker';
import DateMaster from '../utils/date_master';
import TackMapper from '../utils/tack_mapper';
import UserLoginService from '../../services/user_login';

export const reset = () => {
  return { type: types.TACK_RESET };
}

export const pauseTack = (slug) => {
  return async(dispatch) => {
    try {
      const tackData = await TackPauser.pause(slug);
      const tack = {
        slug: slug,
        pausedAt: DateMaster.parseUTC(tackData.paused_at),
        wordText: tackData.word_text
      }
      dispatch({ type: types.TACK_PAUSED, tack });
    } catch(error) {
      dispatch({ type: types.TACK_PAUSED_ERROR, error });
    }
  }
}

export const loggedOutTack = (wordText, email, targetLanguage) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.TACK_CREATING });
      const tackData = await LoggedOutTacker.tack(wordText, email, targetLanguage);
      const tack = TackMapper.map(tackData);
      dispatch({ type: types.TACK_CREATED, tack });
    } catch(error) {
      dispatch({ type: types.TACK_ERROR, error });
    }
  }
}

export const tack = (wordText, targetLanguage) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.TACK_CREATING });
      const tackData = await Tacker.tack(wordText, targetLanguage);
      dispatch(UserActions.fetchAccount());
      const tack = TackMapper.map(tackData);
      dispatch({ type: types.TACK_CREATED, tack });
    } catch(error) {
      dispatch({ type: types.TACK_ERROR, error });
    }
  }
}

export const tackForWordText = (wordText) => {
  return async(dispatch) => {
    if (UserLoginService.isLoggedIn()) {
      try {
        dispatch({ type: types.TACK_RETRIEVING });
        const tackData = await Tacker.tackForWordText(wordText);
        const tack = TackMapper.map(tackData);
        dispatch({ type: types.TACK_RETRIEVED, tack });
      } catch(error) {
        dispatch({ type: types.TACK_ERROR, error });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/tack/actions.js